import BlogArticlePage from '../components/BlogArticles';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Psyop | Cartwheel',
  'How an award-winning studio repaired imperfect motion capture without reshooting the performance.',
);

export default BlogArticlePage;
